import React from 'react';
import { Grid, Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './ServicesSection.css';
import '../styles/SectionTitles.css';
import img1 from '../assets/Images/softwaredevelopment.png';
import img2 from '../assets/Images/mobileapps.png';
import img3 from '../assets/Images/webdevelopment.png';
import img4 from '../assets/Images/ai&automation.png';
import img5 from '../assets/Images/cloud.png';
import img6 from '../assets/Images/uiux.png';

const services = [
  {
    icon: '💻',
    title: 'Software Development',
    desc: 'Custom software solutions tailored to your business needs.',
    img: img1,
    path: '/services/software-development'
  },
  {
    icon: '📱',
    title: 'Mobile Apps',
    desc: 'Native and cross-platform mobile applications for iOS and Android.',
    img: img2,
    path: '/services/mobile-apps'
  },
  {
    icon: '🌐',
    title: 'Web Development',
    desc: 'Modern, responsive, and scalable web applications.',
    img: img3,
    path: '/services/web-development'
  },
  {
    icon: '🤖',
    title: 'AI & Automation',
    desc: 'Intelligent automation and AI-powered solutions.',
    img: img4,
    path: '/services/ai-automation'
  },
  {
    icon: '☁️',
    title: 'Cloud Solutions',
    desc: 'Scalable cloud infrastructure and deployment.',
    img: img5,
    path: '/services/cloud-solutions'
  },
  {
    icon: '🎨',
    title: 'UI/UX Design',
    desc: 'User-centered design for delightful digital experiences.',
    img: img6,
    path: '/services/ui-ux-design'
  },
];

const directions = [
  { y: 100, opacity: 0 }, // bottom
  { y: 100, opacity: 0 }, // bottom
  { y: 100, opacity: 0 }, // bottom
  { y: 100, opacity: 0 }, // bottom
  { y: 100, opacity: 0 }, // bottom
  { y: 100, opacity: 0 }, // bottom
];

const ServicesSection = () => (
  <Box className="services-section-root services-section-bg">
    <Container maxWidth="lg" sx={{ py: { md: 10 } }}>
      <Box className="services-header">
        <Box className="section-title-row">
          <Typography variant="h3" className="section-title-gradient">
            Services
          </Typography>
          <span className="section-title-line" />
        </Box>
        <Typography variant="h6" className="section-subtitle">
          Suite of Our App Development Services
        </Typography>
      </Box>
      <Box className="services-masonry">
        {services.map((service, idx) => (
          <motion.div
            key={service.title}
            initial={directions[idx % directions.length]}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            style={{ height: '100%' }}
          >
            <Link to={service.path} style={{ textDecoration: 'none', display: 'block', height: '100%' }}>
              <Box className="service-card">
                <img src={service.img} alt={service.title} className="service-card-bg" />
                <div className="service-card-overlay" />
                <Box className="service-card-content">
                  <Typography variant="h5" className="service-card-title">
                    {service.title}
                  </Typography>
                  <Typography className="service-card-desc">
                    {service.desc}
                  </Typography>
                </Box>
              </Box>
            </Link>
          </motion.div>
        ))}
      </Box>
    </Container>
  </Box>
);

export default ServicesSection; 